import React, { useEffect } from 'react';
import { Grid, ButtonGroup, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';

const SensorViewFooter = ({ sensors }) => {
    const dispatch = useDispatch();

    const sensorCount = sensors ? Object.keys(sensors).length : 0;

    useEffect(() => {
        if (sensorCount > 7) {
            const lineCount = Math.ceil(sensorCount / 7);
            const sensorSpace = lineCount * 40;
            const liveTrackingLayoutPayload = {
                sidebarWidthratio: 0.25,
                minFooter: 40 + sensorSpace,
            };
            dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
            //console.log("re rendering", lineCount, sensorSpace);
        }
    }, [sensorCount, dispatch]);
    useEffect(() => {
        console.log("sensors", sensors);
    }, [sensors]);

    return (
        <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            alignContent="center"
            wrap='wrap'
            spacing={1}
            style={{
                marginLeft: '0px',
                marginBottom: '10px',
                width: '90vw',
            }}
        >
            {
                sensors && Object.keys(sensors).map(name =>
                    <Grid item key={name}>
                        <ButtonGroup>
                            <Button variant="contained" style={{
                                color: 'White',
                                backgroundColor: 'DodgerBlue'
                            }} size="small">
                                {`${name}: `}
                            </Button>
                            <Button variant="outlined" style={{
                                color: 'blueGray',
                            }} size="small">
                                <span><b>{` ${sensors[name]} `}</b></span>

                            </Button>
                        </ButtonGroup>
                    </Grid>
                )
            }

        </Grid>
    );
}

export default React.memo(SensorViewFooter);

/**
 * <Typography style={{ display: 'inline' }} variant="body1">
                            <span style={{ color: 'SlateBlue' }}>{`${name}: `}</span>
                        </Typography>
                        <Typography style={{ display: 'inline' }} variant="subtitle1">
                            {` ${sensors[name]} `}
                        </Typography>
 */